export default {
  project: 'Digit',
  title: 'Accounting',
  search: 'Search',
  filterBar: {
    schemes: {
      label: 'Scheme',
    },
  },
  searchCategories: {
    caseId: 'Case ID',
    recordId: 'Record ID',
    moneyIn: 'Money in (due)',
    moneyOut: 'Money out (due)',
  },
  bankAccount: 'Bank account',
  reconciled: 'Reconciled',
  unreconciled: 'Unreconciled',
  actions: {
    default: 'Actions',
    agentStatements: 'Send agent statements',
    withdrawIncome: 'Withdraw income',
    closeAccountingPeriod: 'Close accounting period',
    accountActions: 'Account actions',
  },
  adjustments: {
    popover: {
      title: 'Set adjustment',
      adjustmentLimit: 'Adjustment limit: +/-{{value}}',
      moneyInput: {
        hint: {
          max: 'Max',
          min: 'Min',
        },
      },
      totalReceived: 'Total with adjustment',
      totalDue: 'Total selected',
      adjustment: 'Adjustment',
      addAdjustment: 'Add adjustment',
      submit: 'Apply adjustment',
    },
  },
  tableColumnNames: {
    date: 'Date',
    paymentRef: 'Payment Ref',
    moneyIn: 'Money in',
    moneyOut: 'Money out',
    balance: 'Balance',
    status: 'Status',
    payer: 'Payer/payee',
    actions: '',
    client: 'Client',
    caseNo: 'Case no.',
    grossPremium: 'Gross premium',
    tax: 'Tax',
    netPremium: 'Net premium',
    policyFee: 'Policy fee',
    agentCommission: 'Agent commission',
    amountWithdrawn: 'Amount withdrawable',
  },
  form: {
    submit: 'Submit',
  },
  layout: {
    nav: {
      ledger: 'Ledger',
      bankAccounts: 'Bank accounts',
      reports: 'Reports',
    },
  },
  fileupload: {
    dragFile: 'Drag file to upload',
    or: 'or',
    error:
      'The file type upload is not accepted. Please upload transactions in CSV or XLSX format.',
    uploadFile: 'Choose file...',
    invalidFileFormat:
      'We do not accept uploads in this format. Please upload payments manually using our transaction table',
  },
  newPayment: {
    title: 'Add bank transactions',
    description: 'Add your transactions into the table below to import',
    save: 'Add payments',
    uploadNewFile: 'Upload New File',
    types: {
      fileUpload: 'Upload file',
      manual: 'Copy and paste transactions',
      title: 'How will you upload transactions',
      describe: 'Select how you will upload bank transactions',
      next: 'Next',
    },
  },
  closePeriod: {
    title: 'Close accounting period',
    submit: 'Close accounting period',
    success: 'Period successfuly closed',
    description:
      'Manage the locking of your data to prevent changes being made on reconciled entries within a specified period. The balance for this period must be ',
    irreversibleAction:
      ' Please bear in mind this is an irreversible action and cannot be undone.',
    lastClosingDate: 'Last closing date: ',
    form: {
      date: 'Closing date',
      notes: 'Notes',
      endOf: 'This is the end of my financial year',
    },
    confirmation: {
      title: 'Are you sure you want to close accounting?',
      copy: 'WARNING: The Following action is irreversible. If you proceed, you will not be able to re-open the accounting period and no reconciled payments within the date set can be amended from this point on.',
      submit: 'Close accounting period',
    },
  },
  withdrawIncome: {
    title: 'Withdrawable income',
    totalWithdrawn: 'Master Total after withdrawal:',
    totalAmount: 'Withdrawal Amount:',
    success: 'Has been Successful',
    fee: 'Fees amount:',
    commision: 'Commission amount:',
    form: {
      paymentType: 'Payment type',
      reference: 'Reference',
      referencePlaceholder: 'Insert reference',
      date: 'Date',
      notes: 'Notes',
      withdrawalAmount: 'Withdrawal amount ({{amount}} available)',
    },
    table: {
      title: 'Commission & fees withdrawable from {{count}} payments',
    },
  },
  agentStatements: {
    title: 'Send agent statements',
    buttons: {
      submit: 'Send',
    },
    fields: {
      selectAgent: 'Select agent',
      dateRange: 'Date range (optional)',
      dateRangeHint:
        'Agent statements for cases with an inception date within this range will be sent. Leaving this blank will mean a statement for all outstanding payments will be sent',
      filesToInclude: 'Files to include',
      includeCsv: 'Include CSV',
      includePdf: 'Include PDF',
      sendFrom: 'Address to send agent statement from',
      sendFromHint: 'You can amend this address on the ',
      settingsPage: 'settings page',
      advancedSettings: 'Advanced settings',
      summary: 'Send summary of statement run to',
      sendAll: 'Send all statement to specified email address',
    },
    helpFields: {
      sendAll:
        'Select this option to send all Agent statements of account to a specific email address – this option should only be used to send the statements of account to in-house admin Users. Do not use this option to send the statements of account to an individual Agent email address as statements of accounts for all Agent accounts will be sent to that email address – if a specific Agent needs a copy of their statement of account use the search function (above) to select and send a statement of account.',
      summary:
        'Select this option to send a summary of the statement of accounts to a specific email address - this option should only be used to send a summary to in-house admin Users. Do not use this option to send a summary to an individual Agent email address as a summary of all Agent accounts will be sent to that email address – if a specific Agent needs a copy of their statement of account use the search function (above) to select and send a statement of account.',
      selectAgent:
        "Select a specific Agent from this list to send a Statement of Account to only that Agent. Care must be taken if selecting the option of 'All agents' - if this option is selected a Statement of Account will be sent by email to all active Agents.",
    },
  },
  remittanceNotes: {
    from: 'From',
    to: 'To',
    success: 'Successfuly created Remittance Note',
    insurerPayment: 'Record insurer payment',
    agentRemittanceNote: 'Record agent remittance note',
    policySelected: '1 case selected',
    policySelected_plural: '{{ count }} cases selected',
    totalAmount: 'Total amount due: {{ value }}',
    total: 'Total: ',
    paymentAmount: 'Payment amount: {{ value }}',
    form: {
      paymentType: 'Payment type',
      reference: 'Reference',
      date: 'Date',
      paymentAmount: 'Payment amount',
      notes: 'Notes (optional)',
    },
    tableHeaders: {
      client: 'Client',
      case: 'Case',
      premiumNet: 'Premium net',
      tax: 'Tax',
      fees: 'Fees',
      premiumGross: 'Premium gross',
      commissionDue: 'Commission due',
      amountToPay: 'Amount to pay',
    },
    title: 'Remittance Advice',
    print: 'Print',
    paymentDate: 'Payment Date:',
    issueDate: 'Issue Date:',
    columns: {
      client: 'Client',
      caseNumber: 'Case number',
      grossPremium: 'Gross premium',
      tax: 'Tax',
      netPremium: 'Net Premium',
      policyFee: 'Policy fee',
      agentCommission: 'Agent comm',
      paymentAmount: 'Payment Amount',
    },
  },
  bankAccounts: {
    title: 'Bank accounts',
    noBankAccount: 'No bank accounts for selected country',
    createdSuccess: 'Created new Bank account',
    createTitle: 'Add a bank account',
    createAdd: 'Add account',
    updateTitle: 'Manage account',
    updateSave: 'Save changes',
    updatedSuccess: 'Successfuly updated bank account',
    deleteTitle: 'Are you sure you want to delete this account',
    deleteMessage:
      'WARNING: The following action is irreversible. If you proceed, you will lose all transactions previously uploaded.',
    deleteAccount: 'Delete account',
    deleteSuccess: 'Successfuly deleted bank account',
    deleteButton: 'Delete bank account',
    deleteConfirmation: 'Are you sure you want to delete this bank account?',
    ibanAndBic: 'IBAN: {{iban}} | BIC: {{bic}}',
    iban: 'IBAN: {{iban}}',
    sortCodeAndAccountNumber:
      'Sortcode: {{sortcode}} | Account no: {{accountno}}',
    fields: {
      accountName: 'Account name',
      sortCode: 'Sort code',
      accountNumber: 'Account number',
      balance: 'Starting balance (optional)',
      bic: 'BIC',
      iban: 'IBAN',
      bicOptional: 'BIC (optional)',
      ibanOptional: 'IBAN (optional)',
      accountType: 'Account type',
      statutory: 'Statutory or Non-Statutory',
      bankName: 'Bank name',
      addressLine1: 'Bank address (optional)',
    },
    tabs: {
      accountStatements: 'Account statements',
      schemeserveTransactions: 'SchemeServe transactions',
      accountReconciliation: 'Account reconciliation',
    },
    actions: {
      enableBankFeed: 'Enable open banking',
      addPayment: 'Add payment',
    },
    types: {
      title: 'How will you upload transactions?',
      describe: 'Select how you will upload bank transactions',
      openBank: 'Sync my bank account',
      manualBank: 'Upload transactions manually',
      next: 'Next',
    },
  },
  openBanking: {
    fields: {
      sortCode: 'Sort code: {{value}}',
      sortCodeHeader: 'Sort code',
      accountNumber: 'Account number: {{value}}',
      accountNumberHeader: 'Account number',
      balance: 'Starting balance (Optional)',
      bic: 'BIC: {{value}} | ',
      bicHeader: 'BIC',
      iban: 'IBAN: {{value}}',
      ibanHeader: 'IBAN',
    },
    openBanking: 'Open banking:',
    connectAndRemaining: 'Connected | {{count}} days left of connection ',
    expiry_zero: 'Connection expired',
    expiry_one: '{{count}} day left',
    expiry_other: '{{count}} days left',
    renewConnection: 'Renew connection',
    alertCopy:
      'The connection to {{name}} has expired. You must re-connect the bank account to resume transaction imports from the banking provider.',
    lastImported: 'Last imported:',
    availableBankAccounts: 'Available bank accounts:',
    tooManyAccounts:
      'You have selected {{count}} bank accounts from your banking provider, however you can only have 1 bank account in Digit. Please choose which bank account you wish to connect.',
    connectAccount: 'Connect selected account',
    importTransactions: 'Import transactions',
    editDetails: 'Edit details in Digit',
    connectAnotherAccount: 'Connect with another account',
    canNotFindMatchingAccount: 'Could not find matching account',
    whichAccount: 'Which bank account do you wish to connect?',
    importDate: 'Select import date',
    selectOpenBankingAccount: 'Which bank account do you wish to connect?',
    selectBank: 'Select your bank',
    connectBankToDigit: 'Connect {{name}} to Digit',
    reconnectBankToDigit: 'Renew connection between {{name}} and Digit',
    addAccountDetails: 'Add account details',
    selectCountry: 'Select your country',
    agreeAndConnect: 'Agree and connect account',
    agreeAndReconnect: 'Agree and re-connect account',
    createBankAccount: 'Create bank account',
    continueProcess: 'Continue Process on new tab',
    openInTabAction: 'If new tab does not open visit',
    openInNewTab: 'Open new tab',
    provider: 'GoCardless',
    providerConfirmation:
      'Digit partners with GoCardless to securely import your transactions directly from your banking provider. This process is regulated and supervised by the FCA. ',
    learnMore: ' Learn more',
    onceConnected: 'Once connected it can pull through:',
    confirmationList: {
      itemOne: 'Account name, number and sortcode',
      itemTwo: 'Account balance',
      itemThree: 'Card number',
      itemFour: 'Transaction details',
    },
    numberOfDaysNotice:
      'Digit will have access to this information for 90 days, after which you will be prompted to renew the connection. You can de-activate the connection at any time.',
    balance: 'Balance',
    readyToConnect: 'Ready to connect',
    bankTransactionSelectDate:
      'Select the date from which you want to import bank transaction:',
    bankTransactionWarning:
      'Please make sure to add any bank account transactions up until 23:59 on {{date}} as these will not be pulled through from the banking provider.',
    dupBankTransactionsWarning:
      'There are transactions in the bank account for the date selected. If you import transactions this may result in duplicate entries.',
    revokeConnection: {
      title: 'Revoke open banking connection',
      submit: 'Revoke connection',
      confirm: 'I understand and wish to proceed',
      copy: 'WARNING: The following action will remove the open banking connection from this bank account',
      success: 'Open banking connection successfully revoked',
    },
    noBanks:
      'This country is not currently supported by GoCardless. Please select a different country.',
    connectBankFeed: 'Connect bank feed',
    inviteAlertCopy:
      'Bank feeds are available for this account. Connect the bank feed to automatically import transactions directly from your banking provider.',
    disconnectBankFeed: 'Disconnect bank feed',
    confirmConnection:
      'Confirm you wish to continue with connecting to open banking',
  },
  ledger: {
    tabs: {
      accountsPayable: 'Accounts payable',
      accountsReceivable: 'Accounts receivable',
    },
    fields: {
      type: 'Type',
      dateRange: 'Date range',
      view: 'View',
    },
    types: {
      insurer: 'Insurer',
      agent: 'Agent',
      client: 'Client',
      all: 'All',
    },
    views: {
      unreconciled: 'Unreconciled',
      reconciled: 'Reconciled',
    },
    buttons: {
      recordInsurerPayment: 'Record payment',
      recordAgentPayment: 'Record remittance note',
      tooltip:
        'Please filter to an individual agent/client/insurer and select payments',
    },
    allocationBar: {
      deselectAll: 'Deselect all',
      total: 'Total selected: {{amount}}',
    },
    multipleTransactorsSelected: 'Unable to select transactor',
  },
  tooltips: {
    agent: 'Agent',
    insurer: 'Insurer',
    client: 'Direct Client',
  },
  reports: {
    titles: {
      clientageddebt: 'Client aged debt',
      clientageddebtdetail: 'Client aged debt detail',
      agentageddebt: 'Agent aged debt',
      agentageddebtdetail: 'Agent aged debt detail',
      agentbalance: 'Agent balances',
      insurerageddebt: 'Insurer aged debt',
      insureragedcredits: 'Insurer aged credits',
      insureragedcreditsdetail: 'Insurer aged credits detail',
      trialbalance: 'Trial balance',
      trialbalancedetail: 'Trial balance detail',
      clientmoneycalculation: 'Client money calculation',
      clientmoneycalculationdetail: 'Client money calculation detail',
      profitandloss: 'Profit and loss',
      profitandlossdetail: 'Profit and loss detail',
      balancesheet: 'Balance sheet',
      balancesheetdetail: 'Balance sheet detail',
      reports: 'Reports',
      funding: 'Funding',
      fundingdetail: 'Funding detail',
      earnedincome: 'Earned income',
      earnedincomedetail: 'Earned income detail',
      unearnedincome: 'Unearned income',
      unearnedincomedetail: 'Unearned income detail',
      adjustments: 'Adjustments',
      adjustmentsdetail: 'Adjustments detail',
    },
    settings: {
      title: 'Report settings',
      dateBasis: 'Date basis',
      dataSettings: 'Data settings (Insurer aged credits)',
      futureDates: 'Include future dates in report',
      transactionDate: 'Transaction date',
      inceptionDate: 'Inception date',
      dateBasisHint:
        'Switch date basis of all reports between Transaction date (On cover date) and Inception date.',
    },
    buttons: {
      exportCsv: 'Export CSV',
      exportPdf: 'Export PDF',
      summary: 'Summary',
      detail: 'Detail',
    },
    labels: {
      asAtDate: 'As at date',
    },
    columns: {
      accountName: 'Account',
      accountType: 'Account type',
      balance: 'Balance',
      masterAccountId: 'Master account ID',
      currencyCode: 'Currency code',
      currency: 'Currency',
      transactionDate: 'Transaction date',
      debitAmount: 'Debit',
      creditAmount: 'Credit',
      debit: 'Debit',
      credit: 'Credit',
      debits: 'Debit',
      credits: 'Credit',
      clientId: 'Client ID',
      payer: 'Payer',
      caseInsurerId: 'Insurer ID',
      caseAgentId: 'Case agent ID',
      caseClientId: 'Case client ID',
      caseInsurerName: 'Case insurer name',
      caseAgentName: 'Case agent name',
      caseClientName: 'Case client name',
      clientName: 'Client name',
      caseId: 'Case ID',
      caseRecordId: 'Case record ID',
      caseRecordRiskGroupId: 'Risk group ID',
      riskGroupName: 'Risk group name',
      recordType: 'Record type',
      recordStatus: 'Record status',
      inceptionDate: 'Inception date',
      netPremium: 'Net premium',
      tax: 'Tax',
      policyFee: 'Policy fee',
      premium: 'Premium',
      commissionToAgent: 'Commission to agent',
      commissionFromInsurer: 'Commission from insurer',
      '0-30': '0-30',
      '31-60': '31-60',
      '61-90': '61-90',
      '91-120': '91-120',
      '120+': '120+',
      transaction: 'Transaction',
      date: 'Date',
      event: 'Event',
      insurer: 'Insurer',
      insurerId: 'Insurer ID',
      insurerName: 'Insurer',
      agent: 'Agent',
      agentId: 'Agent ID',
      agentName: 'Agent',
      client: 'Client',
      caseRecord: 'Case record',
      riskGroup: 'Risk group',
      fundingAmount: 'Funding amount',
      scheme: 'Scheme',
      schemeId: 'Scheme ID',
      total: 'Total',
      payee: 'Payee',
      account: 'Account',
      accountingTransactionId: 'Accounting transaction ID',
      accountingTransactionAllocationId: 'Accounting transaction allocation ID',
      accountingAccountId: 'Accounting account ID',
      originEvent: 'Origin event',
      accountBalance: 'Account balance',
      isAllocationContra: 'Is allocation contra',
      hasAllocationContra: 'Has allocation contra',
      writeOff: 'Write off',
      insurerBalance: 'Insurer balance',
      agentBalance: 'Agent balance',
      clientBalance: 'Client balance',
      caseBalance: 'Case balance',
      caseRecordRiskGroupBalance: 'Case record risk group balance',
      caseRecordBalance: 'Case record balance',
      bankTransactionId: 'Bank transaction ID',
      bankAccountId: 'Bank account ID',
      bankTransactionDate: 'Bank transaction date',
      reference: 'Reference',
      bankDebit: 'Bank debit',
      bankCredit: 'Bank credit',
      openBankingTransactionId: 'Open banking transaction ID',
      adjustmentAmount: 'Adjustment amount',
      sSTransactionId: 'SchemeServe transaction ID',
      paymentType: 'Payment type',
      paymentRef: 'Payment ref',
      sSTransactionDate: 'SchemeServe transaction date',
      transactionDebitAmount: 'Transaction debit amount',
      transactionCreditAmount: 'Transaction credit amount',
      insurersPayable: 'Insurers payable',
      incomeWithdrawable: 'Income withdrawable',
      paymentFlow: 'Payment flow',
      accountingTransactionDate: 'Accounting transaction date',
      sSDebit: 'SchemeServe debit',
      sSCredit: 'SchemeServe credit',
      totalAdjustments: 'Total adjustments',
      accountCategory: 'Account category',
    },
  },
  matchModal: {
    title: 'Match transactions',
    paymentDetails: 'Payment details',
    paymentTotal: 'Payment total:',
    date: 'Date',
    name: 'Name',
    reference: 'Reference',
    type: 'Type',
    amount: 'Amount',
    credit: 'Credit',
    debit: 'Debit',
    transactionsHeader: 'Search SchemeServe transactions',
    transactionsDescription:
      'Search and select the transactions that make up this payment',
    selectedTransactions: 'Selected transactions:',
    transactor: 'Transactor',
    transactorType: 'Transactor type',
    difference: 'Difference:',
  },
  paymentModal: {
    title: 'Viewing Details for Payment Ref: {{ ref }}',
    total: 'Total:',
    export: 'Export',
    viewRa: 'View RA',
    cancel: 'Close',
    bankPayment: 'Matched bank account payment',
    fields: {
      agent: 'Agent',
      paymentType: 'Payment type',
      date: 'Date',
      paymentAmount: 'Payment amount',
      notes: 'Notes',
    },
    columns: {
      client: 'Client',
      caseNumber: 'Case number',
      transactionId: 'Transaction ID',
      grossPremium: 'Gross premium',
      tax: 'Tax',
      netPremium: 'Net Premium',
      policyFee: 'Policy fee',
      agentCommission: 'Agent comm',
      paymentAmount: 'Payment Amount',
    },
    delete: {
      copy: 'This will delete the current transaction',
      title: 'Delete transaction',
      confirm: 'Are you sure you want to delete this transaction?',
    },
  },
  fileUpload: {
    title: 'Upload transactions',
    separateMoneyInAndOut: 'Separate money in and out',
    buttons: {
      cancel: 'Cancel',
      submit: 'Upload transactions',
    },
  },
  bankAccountPayment: {
    payee: 'Payee',
    payer: 'Payer',
    moneyIn: 'Money in',
    moneyOut: 'Money out',
    date: 'Date',
    paymentRef: 'Payment ref',
    title: 'View Payment',
    transactorType: 'Transactor type',
    transactor: 'Transactor',
    submit: 'Submit',
    close: 'Close',
    form: {
      success: 'Payment assigned to {{transactorType}} {{transactorId}}',
      successAll: 'Payment assigned successfully',
    },
    delete: {
      button: 'Delete',
      title: 'Delete payment',
      copy: 'WARNING: The following action is irreversible',
      success: 'Successfuly deleted bank account payment',
    },
    unreconcile: {
      button: 'Unreconcile',
      title: 'Are you sure you want to unreconcile this payment?',
      copy: 'WARNING: Unreconciling this payment will remove the link between the account transaction and SchemeServe transaction. If you proceed, the payments will still appear in both areas for you to reconcile again',
      success: 'Successfuly unreconciled transaction',
    },
  },
};
